/** True on a desktop: a window wide enough for one AND a mouse/trackpad. Phones and iPads (even wide, landscape ones)
 *  fail one or the other. Follows the window live. */

import { useEffect, useState } from "react";

const QUERY = '(min-width: 1024px) and (hover: hover) and (pointer: fine)';

export function useIsDesktop(): boolean {
  const [desktop, setDesktop] = useState(() => typeof window !== 'undefined' && window.matchMedia?.(QUERY).matches === true);
  useEffect(() => {
    const mq = window.matchMedia?.(QUERY);
    if (!mq) return;
    const onChange = () => setDesktop(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return desktop;
}
